import { render, staticRenderFns } from "./GrabngoMessage.vue?vue&type=template&id=5c5f38a6&scoped=true"
import script from "./GrabngoMessage.vue?vue&type=script&lang=js"
export * from "./GrabngoMessage.vue?vue&type=script&lang=js"
import style0 from "./GrabngoMessage.vue?vue&type=style&index=0&id=5c5f38a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5f38a6",
  null
  
)

export default component.exports